import { useEffect, useState } from "react";
import { Plug, Webhook } from "lucide-react";
import { API } from "../../lib/api";
import { fmtDate, PROVIDER_LABELS } from "../../lib/format";
import { PageHeader, Loading, StatusBadge, Table, Empty } from "../../components/common";

export default function AdminIntegrations() {
  const [data, setData] = useState(null);
  useEffect(() => { API.get("/admin/integrations").then((r) => setData(r.data)); }, []);
  if (!data) return <Loading label="Loading integrations" />;

  const byProvider = {};
  data.connections.forEach((c) => {
    byProvider[c.provider] = byProvider[c.provider] || { CONNECTED: 0, ACTION_REQUIRED: 0, NOT_CONNECTED: 0 };
    byProvider[c.provider][c.status] = (byProvider[c.provider][c.status] || 0) + 1;
  });

  return (
    <div data-testid="admin-integrations">
      <PageHeader title="Integration Manager" sub="Merchant, bank, and accounting connections across all clients. Statuses are always honest — nothing shows connected until real credentials verify." />

      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {data.supported_providers.map((p) => {
          const counts = byProvider[p] || {};
          return (
            <div key={p} className="card-gov p-5" data-testid={`admin-integration-${p}`}>
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2 font-bold text-navy"><Plug className="h-4 w-4" /> {PROVIDER_LABELS[p]}</div>
              </div>
              <div className="mt-3 grid grid-cols-3 gap-2 text-center">
                <div className="rounded border border-emerald-200 bg-emerald-50 py-2"><div className="money text-lg font-bold text-emerald-700">{counts.CONNECTED || 0}</div><div className="text-[9px] font-bold uppercase text-emerald-600">Connected</div></div>
                <div className="rounded border border-amber-200 bg-amber-50 py-2"><div className="money text-lg font-bold text-amber-700">{counts.ACTION_REQUIRED || 0}</div><div className="text-[9px] font-bold uppercase text-amber-600">Action Req.</div></div>
                <div className="rounded border border-slate-200 bg-slate-50 py-2"><div className="money text-lg font-bold text-slate-500">{counts.NOT_CONNECTED || 0}</div><div className="text-[9px] font-bold uppercase text-slate-400">Not Conn.</div></div>
              </div>
              <p className="mt-3 text-[10px] text-slate-400">Webhook route ready: <code className="font-mono">/api/webhooks/{p}</code>. Add API credentials in Settings to activate.</p>
            </div>
          );
        })}
      </div>

      <h3 className="mb-3 mt-8 flex items-center gap-2 font-bold text-navy"><Webhook className="h-4 w-4 text-gold" /> Webhook Log</h3>
      {data.webhooks.length === 0 ? <Empty title="No webhooks received yet" msg="Merchant, billing, and filing webhooks will be logged here." /> : (
        <Table headers={["Time", "Provider", "Payload", "Status"]} testid="webhook-table">
          {data.webhooks.map((w) => (
            <tr key={w.id} className="border-b border-slate-100">
              <td className="px-4 py-2.5 text-xs text-slate-500">{fmtDate(w.created_at)}</td>
              <td className="px-4 py-2.5 font-mono text-xs">{w.provider}</td>
              <td className="px-4 py-2.5 text-xs">{w.payload_size} bytes</td>
              <td className="px-4 py-2.5"><StatusBadge status={w.status} /></td>
            </tr>
          ))}
        </Table>
      )}
    </div>
  );
}
